import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Moment } from 'moment';

import { DATE_FORMAT_FRIENDLY_WITH_WEEKDAY } from '@shared-constants/date-format-constants';

@Component({
  selector: 'app-modal-content-delete-timesheet',
  templateUrl: './modal-content-delete-timesheet.component.html',
  standalone: false,
})
export class ModalContentDeleteTimesheetComponent implements OnInit {
  @Input() public date!: Moment;
  @Output() public readonly closed = new EventEmitter<boolean>();
  public dateDisplay = '';

  public ngOnInit(): void {
    this.dateDisplay = this.date.format(DATE_FORMAT_FRIENDLY_WITH_WEEKDAY);
  }

  public close(isConfirming: boolean): void {
    this.closed.emit(isConfirming);
  }
}
